import { PLATFORMS } from '../enums/platforms';

export default function PlatformLogo({ platformKey, style }) {
    const platform = PLATFORMS[platformKey];
    if (!platform?.logo) return null;

    return (
        <img
            src={platform.logo}
            alt={platform.name}
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                overflow: 'hidden',
                height: '36px',
                width: '36px',
                minWidth: '36px',
                minHeight: '36px',
                aspectRatio: '1',
                boxSizing: 'border-box',
                borderRadius: '10px',
                maxWidth: '36px !important',
                maxHeight: '36px !important',
                ...style
            }}
        />
    );
}
